export default "__VITE_ASSET__4322bccf__"